import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { tryFetchFieldsMetaDataIfNeeded } from 'store/metaData/fields/actions';
import { DashboardSettings_Details } from 'views';
import { Sider } from '../components';

const defaultProps = {};
const propTypes = {};

class DashboardSettings extends PureComponent {
  componentDidMount() {
    this.props.tryFetchFieldsMetaDataIfNeeded();
  }

  render() {
    return (
      <div>
        <Sider />
        <DashboardSettings_Details />
      </div>
    );
  }
}

const mapStateToProps = ({ metaData }) => ({
  fields: metaData.fields
});
const mapDispatchToProps = {
  tryFetchFieldsMetaDataIfNeeded
};
DashboardSettings.defaultProps = defaultProps;
DashboardSettings.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardSettings);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/container/index.jsx